/**
 * @generated SignedSource<<81173766b8bfa95a0e40ac5ad2d24a44>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type contentSchemaRenderContent$data = {
  readonly " $fragmentSpreads": FragmentRefs<"blockquoteQuoteContent" | "blockquoteQuoteGenericPostiesArticleContent" | "imageContent" | "inlineWidgetContent" | "photoGalleryWidgetContent" | "scmpYoutubeContent">;
  readonly " $fragmentType": "contentSchemaRenderContent";
};
export type contentSchemaRenderContent$key = {
  readonly " $data"?: contentSchemaRenderContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"contentSchemaRenderContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "contentSchemaRenderContent",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "scmpYoutubeContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "imageContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "blockquoteQuoteContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "inlineWidgetContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "photoGalleryWidgetContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "blockquoteQuoteGenericPostiesArticleContent"
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "9e758c697063b4ebd788228265fcfa78";

export default node;
